import {Component, OnInit} from '@angular/core';
import {StepComponent} from '../../step/step.component';
import {EingabeForm} from './eingabe.form';
import {Step, StepService} from '../../services/step.service';
import {Router} from '@angular/router';
import {BekocheckRequestService} from '../services/request.service';
import {BekocheckAnfrage} from '../anfrage/bekocheck.anfrage';
import {ElementService} from '../../services/element.service';
import {PortalService} from '../../services/portal.service';

/**
 * Overwrite the Generic step component for the first section fo the bekocheck.
 *
 * @inheritDoc
 */
@Component({
    selector: 'app-step-eingabe',
    templateUrl: '../../step/step.component.html',
    standalone: false
})
export class EingabeStepComponent extends StepComponent implements OnInit {

  /**
   * (input) data of the user
   */
  anfrage: BekocheckAnfrage;

  /**
   * @inheritDoc
   */
  formConfig: EingabeForm;

  /**
   * Overwrite the label prefix.
   */
  textkeyPrefix = 'bekocheck';

  hideHelpForSteps = [
    'basisdaten/1',
    'basisdaten/2'
  ];

  /**
   * Holds the previous step object to move back.
   */
  previousStep: Step;

  /**
   * @inheritDoc
   */
  constructor(protected stepService: StepService, protected router: Router, protected requestService: BekocheckRequestService,
              protected elementService: ElementService, protected portalService: PortalService) {
    super(stepService, router, elementService);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    // add the correct form config that we need in this steps and init the parent form
    this.formConfig = new EingabeForm();
    super.ngOnInit();

    // get the current input data and preset it
    this.anfrage = this.requestService.getAnfrage();
    this.formConfig.anfrage = this.anfrage;

    // set default values
    if (this.portalService.getConfigAsBool('bekocheck.disable.wohnungseigentuemer')) {
      const nutzungstyp = this.formConfig.getField('nutzungstyp');
      if (nutzungstyp) {
        nutzungstyp.setOptionsDisabled(['wohnungseigentuemer']);
        if (typeof this.anfrage.userInput.nutzungstyp === 'undefined' || this.anfrage.userInput.nutzungstyp !== 'mieter') {
          this.anfrage.userInput.nutzungstyp = 'mieter';
        }
      }
    }

    this.formConfig.setStepComponent(this);
    this.formConfig.setData(this.anfrage.userInput);

    if (this.steps.currentStep && this.hideHelpForSteps.includes(this.steps.currentStep.name)) {
      this.hideHelp();
    }

    // update the previous step
    this.onStepUpdate();

    if (this.steps.currentStep && this.steps.currentStep.name === 'weitere-kostenpositionen/9') {
      this.steps.nextStep = new Step('ergebnis/betriebskostenanalyse', '/bekocheck/ergebnis/betriebskostenanalyse');
    }
  }

  /**
   * @inheritDoc
   */
  saveData(data: { [key: string]: any }) {
    // merge the data with the existing data
    this.anfrage.userInput = {...this.anfrage.userInput, ...data};
    this.requestService.setAnfrage(this.anfrage);

    // save the data also to the server
    this.requestService.saveDataToServer();

    super.saveData(data);
  }

  /**
   * moveon to the next step in the routing
   */
  moveToNextStep(): void {
    if (this.steps.currentStep && this.steps.currentStep.name === 'weitere-kostenpositionen/9') {
      this.router.navigateByUrl(this.portalService.currentPortalId + '/bekocheck/ergebnis/betriebskostenanalyse');
      this.requestService.sendDataToApi();
    }
    else {
      super.moveToNextStep();
    }
  }

  /**
   * Return the next step from a step list
   */
  getNextStepFromList(stepList: Step[]): any {
    // set all data again in the form to avoid using old data for toggle fields
    if (this.anfrage?.userInput && this.formConfig) {
      this.formConfig.updateFields(this.anfrage.userInput);
      // save the data again. In some case some fields are auto updated
      this.saveData({});
    }

    return super.getNextStepFromList(stepList);
  }

  onStepUpdate() {
    super.onStepUpdate();

    // set previous step to intro page
    if (this.steps?.currentStep && this.steps?.currentStep?.name === 'basisdaten/1') {
      this.previousStep = new Step('start', '../../../start');
    }
  }

}
